import { MessageCircle } from "lucide-react";
import { SITE, waLink } from "@/config";

const StickyBar = () => (
  <div
    data-testid="sticky-bottom-bar"
    className="fixed inset-x-0 bottom-0 z-50 border-t border-gold/25 bg-ivory/90 pb-[env(safe-area-inset-bottom)] backdrop-blur-md md:hidden"
  >
    <div className="flex items-center gap-3 px-4 py-3">
      <div className="min-w-0">
        <p className="truncate text-[10px] font-bold uppercase tracking-[0.18em] text-navy/55">
          Complete kit
        </p>
        <p className="font-serif text-xl font-semibold leading-tight text-navy" data-testid="sticky-bar-price">
          {SITE.price}
        </p>
      </div>
      <a
        data-testid="sticky-bar-buy-button"
        href={SITE.razorpayUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="ml-auto flex flex-1 items-center justify-center gap-2 rounded-full bg-gold px-5 py-3.5 text-sm font-extrabold uppercase tracking-[0.12em] text-navy shadow-[0_10px_25px_-10px_rgba(185,155,92,0.7)] transition-colors active:bg-gold-soft"
      >
        Buy Now
      </a>
      <a
        data-testid="sticky-bar-whatsapp-button"
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Order on WhatsApp"
        className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-wa text-[#063A2C] shadow-[0_10px_25px_-10px_rgba(18,140,126,0.6)]"
      >
        <MessageCircle className="h-5 w-5" />
      </a>
    </div>
  </div>
);

export default StickyBar;
